// Close native header disclosures without requiring a navigation framework.
document.addEventListener('click', (event) => {
  document.querySelectorAll('.aw-header-disclosure[open]').forEach((details) => {
    if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
  });
  const anchor = event.target.closest('a[href$="#delivery"]');
  if (anchor) document.getElementById('delivery')?.setAttribute('open', '');
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.aw-header-disclosure[open]').forEach((details) => {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
if (location.hash === '#delivery') document.getElementById('delivery')?.setAttribute('open', '');
// The mobile toolbar activates the existing form, and mirrors its actual variant state.
class AWStickyBuy extends HTMLElement {
  connectedCallback() {
    this.info = document.getElementById(`ProductInfo-${this.dataset.section}`);
    this.button = this.querySelector('button');
    if (!this.info || !this.button) return;
    this.submit = this.info.querySelector('.product-form__submit');
    if (!this.submit) return;
    this.button.addEventListener('click', () => this.submit.click());
    this.refresh = () => {
      const disabled = this.submit.disabled || this.submit.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      this.button.textContent = this.submit.querySelector('span')?.textContent.trim() || '';
      const price = this.info.querySelector('.price:not(.price--on-sale) .price-item--regular, .price--on-sale .price-item--sale');
      const priceText = price?.textContent.trim() || '';
      const selectedSize = this.info.querySelector('input[data-option-name="Size"]:checked');
      const sizeLabel = this.querySelector('.aw-sticky-size');
      if (sizeLabel) sizeLabel.textContent = selectedSize?.value || '';
      const label = this.querySelector('.aw-sticky-price');
      if (label.textContent !== priceText) label.textContent = priceText;
    };
    this.info.addEventListener('change', this.refresh);
    this.observer = new MutationObserver(this.refresh);
    this.observer.observe(this.submit, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    const price = this.info.querySelector(`[id^="price-"]`);
    if (price) this.observer.observe(price, {childList: true, subtree: true});
    this.intersection = new IntersectionObserver(([entry]) => {
      // Only appear after the normal purchase button has scrolled above the viewport.
      this.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
    });
    this.intersection.observe(this.submit);
    this.refresh();
  }
  disconnectedCallback() {
    this.info?.removeEventListener('change', this.refresh);
    this.observer?.disconnect();
    this.intersection?.disconnect();
  }
}
if (!customElements.get('aw-sticky-buy')) customElements.define('aw-sticky-buy', AWStickyBuy);

// Discourage casual image saving; public browser images are not copy-proof.
['contextmenu', 'dragstart'].forEach((eventName) => {
  document.addEventListener(eventName, (event) => {
    if (event.target instanceof Element && event.target.closest('img')) {
      event.preventDefault();
    }
  });
});
